import React from 'react';
import { Dialog as HeadlessDialog, DialogPanel, DialogBackdrop, DialogTitle } from '@headlessui/react';
import { cn } from './utils';

export type DialogSize = 'sm' | 'md' | 'lg' | 'xl';

export interface DialogProps {
  open: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: DialogSize;
  className?: string;
  /** When true, clicking the backdrop closes the dialog. Default true. */
  closeOnBackdrop?: boolean;
}

const sizeClass: Record<DialogSize, string> = {
  sm: 'bh-dialog__panel--sm',
  md: 'bh-dialog__panel--md',
  lg: 'bh-dialog__panel--lg',
  xl: 'bh-dialog__panel--xl',
};

export function Dialog({
  open,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  className,
  closeOnBackdrop = true,
}: DialogProps) {
  return (
    <HeadlessDialog
      open={open}
      onClose={() => {
        if (closeOnBackdrop) {
          onClose();
        }
      }}
      className="bh-dialog"
    >
      <DialogBackdrop className="bh-dialog__backdrop" transition />
      <div className="bh-dialog__container">
        <DialogPanel
          transition
          className={cn('bh-dialog__panel', sizeClass[size], className)}
        >
          {title ? (
            <div className="bh-dialog__header">
              <DialogTitle className="bh-dialog__title">{title}</DialogTitle>
              <button type="button" className="bh-dialog__close" onClick={onClose} aria-label="Close">
                ×
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="bh-dialog__close bh-dialog__close--floating"
              onClick={onClose}
              aria-label="Close"
            >
              ×
            </button>
          )}
          <div className="bh-dialog__body">{children}</div>
          {footer ? <div className="bh-dialog__footer">{footer}</div> : null}
        </DialogPanel>
      </div>
    </HeadlessDialog>
  );
}
